import React from 'react';
import { Typography, Spin } from 'antd';

const { Title } = Typography;

const Loading = (props) => {
    return (
        <div className="loader">
            <Spin size="large" spinning />
            <Title level={4} className="mt-16">
                Loading...
            </Title>
        </div>
    );
};

export default Loading;
